/**
 * A state that will determine whether logging is enabled or disabled for debugging purpose.
 * Please see this package `README.md` for more information
 */
export let isLoggingEnabled = false

// Set logging state above to true
export const enableLogging = () => {
  isLoggingEnabled = true
}

// Set logging state above to false
export const disableLogging = () => {
  isLoggingEnabled = false
}
